import React, { Fragment, useContext, useState } from 'react'
import Helpdeskdetails from './Helpdeskdetails';
import MasterinventoryDetails from './Masterinventorydetails';
import SendOutForRepairDetails from './SendOutForRepairDetails';
import UncoveredRepairDetails from './UncoveredRepairDetails';
import ArchiveUsersDetails from './ArchiveUsersDetails';
import SignatureDetails from './SignatureDetails';
import SchoolDetails from './SchoolDetails';
import PageHead from '../../Components/PageHead';
import PaymentLink from './PaymentLink';
import { ThemeContext, UserContext } from '../../App';
import { hasRoleAccess, RoleEnum } from '../../JS/RoleType';
import useConfig from '../../Hooks/useConfig';
import IncreaseGrade from './IncreaseGrade';
import DefaultShipMethod from './DefaultShipMethod';

export function Setting() {
    const [NewAlerts, setNewAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const { UserData } = useContext(UserContext);
    const { state } = useContext(ThemeContext);
    const schoolDetail = state?.ShippingType
    const { terms_service_link, privacy_policy_link, facebook_link, instagram_link,
        twitter_link, linkedin_link, show_UncoveredRepairDetails, show_ArchiveUsersDetails,
        show_increase_grade_setting, show_follow_us_links } = useConfig();
    return (
        <Fragment>
            <PageHead heading={"Settings"} loading={loading} Alerts={NewAlerts} showsearch={false} />
            <div className="container-fluid px-0 mt-2" id="GridDiv">
                <div className="GridBox p-3">
                    <div className="row">
                        <div className='col-md-6 py-2'>
                            <Helpdeskdetails setLoading={setLoading} setNewAlerts={setNewAlerts} />
                        </div>
                        <div className='col-md-6 py-2'>
                            <MasterinventoryDetails setLoading={setLoading} setNewAlerts={setNewAlerts} />
                        </div>
                        <div className='col-md-6 py-2'>
                            <SendOutForRepairDetails setLoading={setLoading} setNewAlerts={setNewAlerts} />
                        </div>
                        {show_UncoveredRepairDetails && hasRoleAccess(UserData.copyrole || UserData.role || null, RoleEnum.COMN_EXCLUDE_VAR) ?
                            <div className='col-md-6 py-2'>
                                <UncoveredRepairDetails setLoading={setLoading} setNewAlerts={setNewAlerts} />
                            </div> : null}
                        <div className='col-md-6 py-2'>
                            <SignatureDetails setLoading={setLoading} setNewAlerts={setNewAlerts} />
                        </div>
                        <div className='col-md-6 py-2'>
                            <PaymentLink setLoading={setLoading} setNewAlerts={setNewAlerts} />
                        </div>
                        {show_ArchiveUsersDetails &&
                            <div className="col-md-6 py-2">
                                <ArchiveUsersDetails setLoading={setLoading} setNewAlerts={setNewAlerts} />
                            </div>
                        }
                        {show_increase_grade_setting &&
                            <div className='col-md-6 py-2'>
                                <IncreaseGrade setLoading={setLoading} setNewAlerts={setNewAlerts} />
                            </div>
                        }
                        {schoolDetail == 2 && (
                            <div className='col-md-6 py-2'>
                                <DefaultShipMethod setLoading={setLoading} setNewAlerts={setNewAlerts} />
                            </div>
                        )}
                        <div className="col-12 py-2">
                            <SchoolDetails setLoading={setLoading} setNewAlerts={setNewAlerts} />
                        </div>
                    </div>
                    <div className='col-12 py-2'>
                        <div className='greyBox '>
                            <div className="row align-items-center">
                                <div className='col-md-6'>
                                    <a className='footerlabel fw-semibold' style={{ color: "black" }} target='_blank'
                                        href={terms_service_link}>Terms of Service</a>
                                    <label className='px-2 font-18'>|</label>
                                    <a className='footerlabel fw-semibold' style={{ color: "black" }} target='_blank'
                                        href={privacy_policy_link}
                                    >Privacy Policy</a>
                                </div>
                                {show_follow_us_links &&
                                    <div className='col-md-6 d-flex align-items-center justify-content-end'>
                                        <b>FOLLOW US</b>
                                        <div className='d-flex align-items-center justify-content-evenly ps-4'>
                                            <a href={facebook_link} target="_blank" rel="noopener" data-linktype="social" data-socialnetwork="Facebook">
                                                <img src='/images/facebook.svg' className='img-fluid mx-3' style={{ height: "20px", width: "20px" }} />
                                            </a>
                                            <a href={twitter_link} target="_blank" rel="noopener" data-linktype="social" data-socialnetwork="Twitter">
                                                <img src='/images/twitter.svg' className='img-fluid mx-3' style={{ height: "20px", width: "20px" }} />
                                            </a>
                                            <a href={instagram_link} target="_blank" rel="noopener" data-linktype="social" data-socialnetwork="Instagram">
                                                <img src='/images/instagram.svg' className='img-fluid mx-3' style={{ height: "20px", width: "20px" }} />
                                            </a>
                                            <a href={linkedin_link} target="_blank" rel="noopener" data-linktype="social" data-socialnetwork="Linkedin">
                                                <img src='/images/linkedin.svg' className='img-fluid mx-3' style={{ height: "20px", width: "20px" }} />
                                            </a>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </Fragment>
    )
}
